import { Scroll, ScrollControls } from "@react-three/drei";
import gsap from 'gsap';
import { useEffect, useRef, useState } from "react";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Video from './Components/Video';

import '../Assets/main.css';
import { NavLink, useLocation } from "react-router-dom";
import { anclaTop } from "./Animations";
import { routeUrl } from "../Utils/pulicUrl";

function qs(el) {return document.querySelector(el)}

export const menuAnimation = (open) => {

    let linea1Rotate = '40deg'
    let linea2Rotate = '140deg'
    let btnHeaderRomboAnt = '2.729vw'
    let btnHeaderRomboDes = '100px'

    let btnHeaderRomboDesAl = '5.729vw'

    let contactoBottom = '1.823vw'
    let reservedBottom = '2vw';
    let btnLinkBottom = '0vw';
    let btnLinkRight = '0vw';
    let btnHeaderRomboIni = '0.4';

    if(window.innerWidth <= 1366){
     btnHeaderRomboDes = '80px'
    }

    if(window.innerWidth <= 1024){
        linea1Rotate = '52deg';
        linea2Rotate = '128deg';
        btnHeaderRomboAnt = '2.729vw'
        btnHeaderRomboDes = '8.201vw'
        contactoBottom = '2vw';
        reservedBottom = '4vw';
        btnLinkBottom = '0vw';
        btnLinkRight = '0vw';
        btnHeaderRomboDesAl = '8.201vw'
    }
    if(window.innerWidth <= 992){
        linea1Rotate = '45deg';
        linea2Rotate = '135deg';
        
    }

    if(window.innerWidth <= 600){
        linea1Rotate = '45deg';
        linea2Rotate = '135deg';
        btnHeaderRomboAnt = '33.333vw'
        btnHeaderRomboDes = '53.333vw'

        btnLinkBottom = '0vw';
        btnLinkRight = '0';
        reservedBottom = '8vw';
        btnHeaderRomboIni = '0';
        btnHeaderRomboDesAl = '53.333vw'
        
    }

    const tl = gsap.timeline({paused: true});
            
    if (qs(".menu")) {
        tl.fromTo(".menu", {height: "0vh"},{
            duration: 0.6,
            ease: 'power2.out',
            height: "100vh",
        },0);
    }
    
    if (qs(".menu .menu__fondo")) {
        tl.fromTo(".menu .menu__fondo", {transform:"skewY(8deg)",marginTop:"8vw",}, {
            duration: 0.6,
            transform:"skewY(0deg)",
            marginTop:"0",
            ease: 'power2.out',
        },0);
    }

    if (qs(".menu__menu")) {
        tl.to(".menu__menu", {
                duration: 0.2,
                onComplete: function () {
                document.querySelector('.menu__menu').classList.add('active');                   
            }
        },0);
    }
    
    if (qs(".menu .menu__line1")) {
        tl.fromTo(".menu .menu__line1", {rotate: '0deg'},{
            duration: 1,
            opacity: 1,
            ease: 'power2.out',
            rotate: linea1Rotate
        },0);
    }

    if (qs(".menu .menu__line1") && qs(".menu .menu__line2")) {
        tl.fromTo(".menu .menu__line2", {rotate: '0deg'}, {
            duration: 1,
            opacity: 1,
            ease: 'power2.out',
            rotate: linea2Rotate
        },0);
        tl.fromTo(".menu .menu__line3",{rotate: '0deg'}, {
            duration: 1,
            opacity: 1,
            ease: 'power2.out',
            rotate: "0deg"
        },0);
    }

    if (qs("header")) {
        tl.to("header", {
            duration: 0.2,
            onComplete: function () {
                document.querySelector('header').classList.add('activeMenu');  
                document.querySelector('.header__menu').classList.add('header__menu-close');                   
            }
        },0.4);
    }
    
    if (qs(".menu .menu__close")) {
        tl.to(".menu .menu__close", {
            duration: 0.6,
            ease: 'power2.out',
            opacity: "1",
        },0.4);
    }

    if (qs(".menu .menu__btn-contacto")) {
        tl.to(".menu .menu__btn-contacto", {
            duration: 0.6,
            ease: 'power2.out',
            bottom: contactoBottom
        },0.4);
    }
    
    if (qs(".menu .menu__btn-contacto .btn__rombo")) {
        tl.fromTo(".menu .menu__btn-contacto .btn__rombo", {
            duration: 0.6,
            height: btnHeaderRomboAnt,
            ease: 'power2.out',
        },{
            duration: 0.6,
            height: btnHeaderRomboDesAl,
            ease: 'power2.out',
        },btnHeaderRomboIni);
    }

    if (qs(".menu .menu__btn-contacto .btn__rombo")) {
        tl.to(".menu .menu__btn-contacto .btn__rombo", {
            duration: 0.6,
            ease: 'power2.out',
            bottom: btnLinkBottom,
            right: btnLinkRight,
        },0.4);
    }

    if (qs(".menu .menu__btn-rs")) {
        tl.fromTo(".menu .menu__btn-rs", {
           bottom: "-7vw",
           right: "4.823vw",
        },{
            bottom: "2vw",
            right: "2.823vw",
         },0.4);
    }
    
    if (qs(".menu .menu__btn-rs .btn__rombo")) {
        tl.fromTo(".menu .menu__btn-rs .btn__rombo", {
            duration: 0.6,
            width: btnHeaderRomboIni,
            ease: 'power2.out',
        },{
            duration: 0.6,
            width: btnHeaderRomboDes,
            ease: 'power2.out',
        },0.4);
    }

    if (qs(".menu .menu__reserved")) {
        tl.to(".menu .menu__reserved", {
            duration: 0.6,
            ease: 'power2.out',
            bottom: reservedBottom,
        },0.4);
    }

    if (qs(".menu .menu__btn-invierte .btn__rombo")) {
        tl.fromTo(".menu .menu__btn-invierte .btn__rombo", {
            duration: 0.6,
            ease: 'power2.out',
            y: "0vw",
            height: btnHeaderRomboAnt,
        },{
            duration: 0.6,
            ease: 'power2.out',
            y: "0vw",
            height: btnHeaderRomboDesAl,
        },0.4);

        if (qs(".btn__menu_home")) {
            tl.fromTo(".btn__menu_home", {
                duration: 0.6,
                ease: 'power2.out',
                rotate: "-30%",
            },{
                rotate: "0%",
            },0.4);
        }

        if (qs(".btn__menu_home svg")) {
            tl.fromTo(".btn__menu_home svg", {
                duration: 0.6,
                ease: 'power2.out',
                width: "0%",
            },{
                duration: 0.6,
                ease: 'power2.out',
                width: "100%",
            },0.4);
        }

        tl.fromTo(".btn__menu_home .btn__rombo_txt span",{
            opacity: 0,
            y: "200%",
            rotateX: '-90deg'
        }, {
            opacity: 1,
            y: 0,
            ease: 'power2.out',
            duration: 0.4,
            stagger: 0.05,
            rotateX: '0deg'
        },0.5);
    }

    if (document.querySelector('.menu__menu').classList.contains('active')) {
        document.querySelector('.menu__menu').classList.remove('active'); 

        document.getElementById("menu__hover_marca").classList.add("is-close");
        document.getElementById("menu__hover_producto").classList.add("is-close");
        document.getElementById("menu__hover_faqs").classList.add("is-close");
        document.getElementById("menu__hover_inversion").classList.add("is-close");

        tl.delay(0.5).timeScale(1).reverse(5);
        document.querySelector("body").classList.remove("activeMenuB");

        setTimeout(function(){
            if (qs("header") && qs('.header__menu')) {
                document.querySelector('header').classList.remove('activeMenu');                   
                document.querySelector('.header__menu').classList.remove('header__menu-close'); 
            }
        },200);

        setTimeout(function(){
            document.getElementById("menu__hover_marca").classList.remove("is-close");
            document.getElementById("menu__hover_producto").classList.remove("is-close");
            document.getElementById("menu__hover_faqs").classList.remove("is-close");
            document.getElementById("menu__hover_inversion").classList.remove("is-close");
        },1000);

    } else {
        if(open){
            tl.play();
            document.querySelector("body").classList.add("activeMenuB");
        }
        
    }


}
export function Header(props) {
    const menu__m = useRef();
    const header = useRef();
    const header__menu = useRef();
    const menu = useRef();

    
    const toogleMenu = () => {
        menuAnimation(1)
    }

    const location = useLocation();

    const [hoveredSection, setHoveredSection] = useState('') 

    const menuHover = (opc,acc) => {
        // opc -> marca, producto, inversion, faqs


        if(acc){
            if (location.pathname.includes(opc)) return

            document.getElementById("menu__"+opc).classList.add("is-active");
            document.getElementById("menu__hover_"+opc).classList.add("is-active");

            menu.current.classList.add('hoverMenu_'+opc);
            header.current.classList.add('hoverMenuHeader_'+opc);

            setHoveredSection(opc)
        }else{
            document.getElementById("menu__"+opc).classList.remove("is-active");
            document.getElementById("menu__hover_"+opc).classList.remove("is-active");

            menu.current.classList.remove('hoverMenu_'+opc);
            header.current.classList.remove('hoverMenuHeader_'+opc);

            setHoveredSection('')
        }
    }
    

    return <>
        <header ref={header} className={ props.classes } id="header">
            <div className="header__logo" >
                <a href={routeUrl("/")}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="header__logo_logo" viewBox="0 0 69.162 40.156"><g fill="#141515" data-name="Grupo 7733"><path d="m0 0 32.494 40.156V23.807L13.2 0Z" data-name="Trazado 37917"/><path d="M55.959 0 36.667 23.807v16.35L69.162 0Z" data-name="Trazado 37918"/><path d="m26.452 0-4.606 5.541 12.726 15.917L47.385 5.724 42.87 0Z" data-name="Trazado 37919"/></g></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" className="header__logo_txt" viewBox="0 0 163.454 13.321"><path d="M163.454,0V13.122h-1.659V4.871l.2-3.46h-.022l-4.737,11.711h-1.485L151.01,1.411h-.022l.2,3.46v8.251h-1.66V0h2.686l3.165,7.973,1.092,3.281h.044l1.113-3.261L160.769,0Zm-26.22,0V8.232a4.794,4.794,0,0,1-1.462,3.807,7.474,7.474,0,0,1-8.373,0,4.776,4.776,0,0,1-1.474-3.807V0h1.746V7.833a4.186,4.186,0,0,0,.95,3.022,4.979,4.979,0,0,0,5.916,0,4.186,4.186,0,0,0,.949-3.022V0ZM107.608,11.631h8.253v1.491h-10V0h1.746ZM84.074,13.122V0H94.181V1.492H85.82V5.726h6.506V7.217H85.82v4.414h8.689v1.491ZM71.5,0V13.122H69.338L63.312,4.334,61.784,1.869h-.022l.088,1.989v9.265H60.19V0h2.161l6,8.748,1.55,2.525h.021l-.087-2.008V0ZM40.126,7.993h5.262L42.746,1.531Zm9.279,5.129H47.549L46.021,9.484H39.494l-1.528,3.639H36.132L41.742,0h2.073Zm-24.059,0H23.6V0h1.746ZM4.824,11.631a5.309,5.309,0,0,0,3.854-1.342,4.945,4.945,0,0,0,1.386-3.728A4.947,4.947,0,0,0,8.678,2.833,5.309,5.309,0,0,0,4.824,1.492H1.746V11.631ZM4.65,0A7.771,7.771,0,0,1,9.966,1.7,6.131,6.131,0,0,1,11.9,6.562a6.131,6.131,0,0,1-1.932,4.861,7.771,7.771,0,0,1-5.316,1.7H0V0Z" fill="#9bcaa6"/></svg>
                </a>
            </div>
            <div className="header__menu-content">
                <button className="header__menu" ref={header__menu} onClick={ () => toogleMenu() }>
                    <span className="header__menu-c1"></span>
                    <span className="header__menu-c2"></span>
                    <span className="header__menu-c3"></span>
                    <span className="header__menu-l1"></span>
                    <span className="header__menu-l2"></span>
                    <span className="header__menu-l3"></span>
                </button>
            </div>
        </header>

        <div className="menu" ref={menu} >
            <div className="menu__fondo"></div>
            <div className="menu__container">
                <div className="menu__line1"></div>
                <div className="menu__line2"></div>
                <div className="menu__line3"></div>
               
                <ul className="menu__menu" ref={menu__m} >
                    <li>
                        <NavLink id="menu__marca" className={"menu__menu-a"} to="/marca" onMouseEnter={() => menuHover("marca",1)}  onMouseLeave={() => menuHover("marca",0)}>
                            <span>M</span>
                            <span>A</span>
                            <span>R</span>
                            <span>C</span>
                            <span>A</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink id="menu__producto" className={"menu__menu-a"} to="/producto" onMouseEnter={() => menuHover("producto",1)}  onMouseLeave={() => menuHover("producto",0)}>
                            <span>P</span>
                            <span>R</span>
                            <span>O</span>
                            <span>D</span>
                            <span>U</span>
                            <span>C</span>
                            <span>T</span>
                            <span>O</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink id="menu__inversion" className={"menu__menu-a"} to={routeUrl("/inversion")} onMouseEnter={() => menuHover("inversion",1)}  onMouseLeave={() => menuHover("inversion",0)}>
                            <span>I</span>
                            <span>N</span>
                            <span>V</span>
                            <span>E</span>
                            <span>R</span>
                            <span>S</span>
                            <span>I</span>
                            <span>Ó</span>
                            <span>N</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink id="menu__faqs" className={"menu__menu-a"} to="/faqs" onMouseEnter={() => menuHover("faqs",1)}  onMouseLeave={() => menuHover("faqs",0)}>
                            <span>F</span>
                            <span>A</span>
                            <span>Q</span>
                            <span>S</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink id="menu__contacto" className={"menu__menu-a"} to="/contacto" >
                        <span>C</span>
                            <span>O</span>
                            <span>N</span>
                            <span>T</span>
                            <span>A</span>
                            <span>C</span>
                            <span>T</span>
                            <span>O</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={routeUrl("/inversion")} /* href="http://invest.dianelum.com/" target="_blank" */ className="menu__menu-a">
                            <span>I</span>
                            <span>N</span>
                            <span>V</span>
                            <span>I</span>
                            <span>E</span>
                            <span>R</span>
                            <span>T</span>
                            <span>E</span>
                        </NavLink>
                    </li>
                </ul>

                <a href={routeUrl("/")} className="btn__menu_home">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 391.41 391.41"><path fill="#141515" stroke="#9bcaa6" strokeWidth="1.5" d="M1.061 195.705 195.706 1.06 390.35 195.705 195.706 390.35z" data-name="Rectángulo 2631"/></svg>
                    <span className="btn__rombo_txt">
                        <span>H</span>
                        <span>O</span>
                        <span>M</span>
                        <span>E</span>
                    </span>
                </a>
                
                <div className="menu__btn-contacto">
                    <NavLink className={"btn__rombo"} to="/contacto">
                        <span className="btn__rombo_cont"></span>
                        <span className="btn__rombo_txt">
                            <span>C</span>
                            <span>O</span>
                            <span>N</span>
                            <span>T</span>
                            <span>A</span>
                            <span>C</span>
                            <span>T</span>
                            <span>O</span>
                        </span>
                    </NavLink>
                </div>


                <div className="menu__btn-rs">
                    <a href="https://www.linkedin.com/company/dianelum-s-l/" target="_blank" className="btn__rombo btn__rombo_svg">
                        <span className="btn__rombo_cont"></span>
                        <span className="btn__rombo_txt">
                            <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.411 24.411"><defs><clipPath id="a"><path fill="#9bcaa6" d="M0 0h24.411v24.411H0z" data-name="Rectángulo 2387"/></clipPath></defs><g fill="#9bcaa6" data-name="Grupo 6706"><path d="M.406 8.026H5.51V24.3H.406z" data-name="Rectángulo 2386"/><g clipPath="url(#a)" data-name="Grupo 6045"><path d="M19.302 7.662q-.289-.032-.592-.044a5.955 5.955 0 0 0-5.03 2.3 3.6 3.6 0 0 0-.222.319V8.062H8.581v16.275h5.1v-7.646a6.643 6.643 0 0 1 .467-3.287 2.49 2.49 0 0 1 2.27-1.272 2.706 2.706 0 0 1 2.884 2.792v9.487h5.1V13.796c0-3.632-1.846-5.78-5.1-6.132" data-name="Trazado 37450"/><path d="M5.918 2.959A2.959 2.959 0 1 1 2.959 0a2.959 2.959 0 0 1 2.959 2.959" data-name="Trazado 37451"/></g></g></svg></span>
                        </span>
                    </a>
                </div>

                <div className="menu__reserved"><span>DIANELUM © ALL RIGHTS RESERVED 2023</span></div>

                <div className="menu__btn-invierte">
                    <NavLink to={routeUrl("/inversion")} /* href="http://invest.dianelum.com/" target="_blank" */ className="btn__rombo">
                        <span className="btn__rombo_cont"></span>
                        <span className="btn__rombo_txt">
                            <span>I</span>
                            <span>N</span>
                            <span>V</span>
                            <span>I</span>
                            <span>E</span>
                            <span>R</span>
                            <span>T</span>
                            <span>E</span>
                        </span>
                    </NavLink>
                </div>


                <div className="menu__hover menu__hover-top" id="menu__hover_marca">
                    <Video 
                        id="menu_hover_1"
                        src="DIA_1B"
                        triggerHover={ hoveredSection == 'marca' }
                    />
                </div>
                <div className="menu__hover menu__hover-bottom" id="menu__hover_faqs">
                    <Video 
                        id="menu_hover_2"
                        src="DIA_61B"
                        triggerHover={ hoveredSection == 'faqs' }
                    />
                </div>
                <div className="menu__hover menu__hover-left" id="menu__hover_producto">
                    <Video 
                        id="menu_hover_3"
                        src="DIA_48"
                        triggerHover={ hoveredSection == 'producto' }
                    />
                </div>
                <div className="menu__hover menu__hover-right" id="menu__hover_inversion">
                    <Video 
                        id="menu_hover_4"
                        src="DIA_43"
                        triggerHover={ hoveredSection == 'inversion' }
                    />
                </div>


            </div>

        </div>

        <div className="page-loader"><span className="loader"></span></div>
        
    </>
}
export function Footer(props) {

    return <>
         <footer className={props.tipo}>
           <div className="footer">
                <div className="footer__txt_top">LUXURY, SUSTAINABILITY & INNOVATION</div>
                <div className="footer__rombo">
                    <NavLink to={routeUrl("/inversion")} /* href="http://invest.dianelum.com/" target="_blank" */>
                        <span>INVIERTE&nbsp;<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.183 125.248"><g stroke="#9bcaa6" strokeWidth="1.5" data-name="Grupo 7257"><path fill="none" strokeMiterlimit="10" d="M125.248 62.621H0" data-name="Línea 58"/><path fill="none" strokeMiterlimit="10" d="M127.183 62.621H1.935" data-name="Línea 59"/><path fill="none" strokeMiterlimit="10" d="m106.903 18.34-88.564 88.564" data-name="Línea 60"/><path fill="none" strokeMiterlimit="10" d="M106.903 106.904 18.339 18.34" data-name="Línea 61"/><path fill="none" strokeMiterlimit="10" d="M62.625 125.248V0" data-name="Línea 62"/><path fill="#141515" d="m46.395 62.626 16.23-16.23 16.23 16.23-16.23 16.23Z" data-name="Trazado 37569"/></g></svg>&nbsp;INVIERTE&nbsp;<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.183 125.248"><g stroke="#9bcaa6" strokeWidth="1.5" data-name="Grupo 7257"><path fill="none" strokeMiterlimit="10" d="M125.248 62.621H0" data-name="Línea 58"/><path fill="none" strokeMiterlimit="10" d="M127.183 62.621H1.935" data-name="Línea 59"/><path fill="none" strokeMiterlimit="10" d="m106.903 18.34-88.564 88.564" data-name="Línea 60"/><path fill="none" strokeMiterlimit="10" d="M106.903 106.904 18.339 18.34" data-name="Línea 61"/><path fill="none" strokeMiterlimit="10" d="M62.625 125.248V0" data-name="Línea 62"/><path fill="#141515" d="m46.395 62.626 16.23-16.23 16.23 16.23-16.23 16.23Z" data-name="Trazado 37569"/></g></svg>&nbsp;INVIERTE&nbsp;<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.183 125.248"><g stroke="#9bcaa6" strokeWidth="1.5" data-name="Grupo 7257"><path fill="none" strokeMiterlimit="10" d="M125.248 62.621H0" data-name="Línea 58"/><path fill="none" strokeMiterlimit="10" d="M127.183 62.621H1.935" data-name="Línea 59"/><path fill="none" strokeMiterlimit="10" d="m106.903 18.34-88.564 88.564" data-name="Línea 60"/><path fill="none" strokeMiterlimit="10" d="M106.903 106.904 18.339 18.34" data-name="Línea 61"/><path fill="none" strokeMiterlimit="10" d="M62.625 125.248V0" data-name="Línea 62"/><path fill="#141515" d="m46.395 62.626 16.23-16.23 16.23 16.23-16.23 16.23Z" data-name="Trazado 37569"/></g></svg>&nbsp;</span>
                    </NavLink>
                </div>
                <div className="footer__linea1"><span></span></div>
                <div className="footer__linea2"><span></span></div>
                <div className="footer__linea3"></div>

                <div className="footer__menu1">
                    <div className="footer__menu_svg">
                        <span className="footer__menu_svg_1"></span>
                        <span className="footer__menu_svg_2"></span>
                        <span className="footer__menu_svg_3"></span>
                    </div>
                    <div>
                        <div className="hover__enlace">
                            <NavLink className="footer__menu-a" to="/marca">MARCA</NavLink>
                            <div className="hover__enlace_line"></div>
                        </div>
                    </div>
                    <div>
                        <div className="hover__enlace">
                            <NavLink className="footer__menu-a" to="/producto">PRODUCTO</NavLink>
                            <div className="hover__enlace_line"></div>
                        </div>
                    </div>
                </div>

                <div className="footer__menu2">
                    <div className="footer__menu_svg">
                        <span className="footer__menu_svg_1"></span>
                        <span className="footer__menu_svg_2"></span>
                        <span className="footer__menu_svg_3"></span>
                    </div>
                    <div>
                        <div className="hover__enlace">
                            <NavLink className="footer__menu-a" to={routeUrl("/inversion")}>INVERSIÓN</NavLink>                           
                            <div className="hover__enlace_line"></div>
                        </div>
                    </div>
                    <div>
                        <div className="hover__enlace">
                            <NavLink className="footer__menu-a" to="/faqs">FAQS</NavLink>
                            <div className="hover__enlace_line"></div>
                        </div>
                    </div>
                </div>

                <div className="footer__btn-contacto">
                    <NavLink className={"btn__rombo "} to="/contacto">
                        <span className="btn__rombo_cont"></span>
                        <span className="btn__rombo_txt">
                            <span>C</span>
                            <span>O</span>
                            <span>N</span>
                            <span>T</span>
                            <span>A</span>
                            <span>C</span>
                            <span>T</span>
                            <span>O</span>
                        </span>
                    </NavLink>
                </div>
                <div className="footer__btn-rs">
                    <a href="https://www.linkedin.com/company/dianelum-s-l/" target="_blank" className="btn__rombo btn__rombo_svg">
                        <span className="btn__rombo_cont"></span>
                        <span className="btn__rombo_txt">
                            <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.411 24.411"><defs><clipPath id="a"><path fill="#9bcaa6" d="M0 0h24.411v24.411H0z" data-name="Rectángulo 2387"/></clipPath></defs><g fill="#9bcaa6" data-name="Grupo 6706"><path d="M.406 8.026H5.51V24.3H.406z" data-name="Rectángulo 2386"/><g clipPath="url(#a)" data-name="Grupo 6045"><path d="M19.302 7.662q-.289-.032-.592-.044a5.955 5.955 0 0 0-5.03 2.3 3.6 3.6 0 0 0-.222.319V8.062H8.581v16.275h5.1v-7.646a6.643 6.643 0 0 1 .467-3.287 2.49 2.49 0 0 1 2.27-1.272 2.706 2.706 0 0 1 2.884 2.792v9.487h5.1V13.796c0-3.632-1.846-5.78-5.1-6.132" data-name="Trazado 37450"/><path d="M5.918 2.959A2.959 2.959 0 1 1 2.959 0a2.959 2.959 0 0 1 2.959 2.959" data-name="Trazado 37451"/></g></g></svg></span>
                        </span>
                    </a>
                </div>
                <div className="footer__btn-scroll">
                    <a href="#" onClick={ () => anclaTop() } className="btn__rombo btn__rombo_svg">
                        <span className="btn__rombo_cont"></span>
                        <span className="btn__rombo_txt">
                            <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.647 40.466"><g fill="none" stroke="#9bcaa6" strokeMiterlimit="10" strokeWidth="1.5" data-name="Grupo 6294"><path d="M19.479 21.782H1.169l9.155-19.981Z" data-name="Trazado 37419"/><path d="M10.323 21.781v18.685" data-name="Línea 43"/></g></svg></span>
                        </span>
                    </a>
                </div>
                <div className="footer__txt_bottom">
                    <div>
                        <div>
                            <div className="hover__enlace hover__enlace-small">
                                <NavLink to="/aviso-legal-y-condiciones-de-uso">Aviso legal</NavLink>
                                <div className="hover__enlace_line"></div>
                            </div>
                        </div>
                    </div>
                    DIANELUM © 2023. <br />TODOS LOS DERECHOS RESERVADOS
                </div>
           </div>
        </footer>
    </>
}